import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=1a53ec62&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "@/styles/super.css?vue&type=style&index=0&id=1a53ec62&prod&scoped=true&lang=css&"
import style1 from "./Terms.vue?vue&type=style&index=1&id=1a53ec62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a53ec62",
  null
  
)

export default component.exports